const divActionLogs = {
  update: 'Atualização',
  comments: 'Comentário',
  update_at: 'atualizado em '
};

export default divActionLogs;
